import axios from '../utils/axios';

export default function fetchNTCPremiumJobCustIds(adminId, params) {
    return axios.get(`/admin/${adminId}/ntc-premium-jobs/cust-ids`, { params })
        .then(res => res.data)
        .catch(err => err);
}
